/**
 * The chat backend files some messages as "<id>:<session key>" while the
 * browser knows them by "<id>" alone. Comparing on the part before the colon is
 * what makes "have I already got this message?" answerable across both forms —
 * and scont resends a message it never saw confirmed as delivered, so the same
 * one can arrive twice.
 */
export const messageKey = (messageId: unknown): string =>
  String(messageId ?? "").split(":")[0];
